module.exports = __webpack_public_path__ + "static/media/gates_of_olympus_1000.pragmaticplay.2d9be1ad.jpeg";